<template>
  <div class="d-flex justify-center download-button">
    <decrypt-button
      v-if="isEncrypted"
      ref="decryptButton"
      :item="item"
      class="file-actions" />
    <em
      v-else
      class="qx-icon icon-download"
      @click="onDownloadOneFileClick" />
  </div>
</template>

<script>
// Elements
import decryptButton from '@/elements/download/decryptButton.vue';

// Mixins
import downloadMixin from '@/mixins/download.js';

import { mapState } from 'vuex';

export default {
  name: 'DownloadFiles',
  components: {
    decryptButton,
  },
  mixins: [downloadMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
    isEncrypted: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      metadata: (state) => state.downloadPage.metadata,
    }),
  },
  methods: {
    onDownloadOneFileClick() {
      this.downloadSelectedFiles([this.item.id]);
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-download {
  color: $base-blue;
  cursor: pointer;
}
</style>
